import activitiesMutations from "./activities.mutation";
import activitiesStates from "./activities.state";
import activitiesActions from "./activities.action";
import activitiesGetters from "./activities.getters";

export default {
  mutations: activitiesMutations,
  state: activitiesStates,
  actions: activitiesActions,
  getters: activitiesGetters
};
